import React from 'react'
import MediaQuery from "react-responsive";
import portrait01 from '../assets/images/portrait/2017/01.jpg'
import portrait02 from '../assets/images/portrait/2017/02.jpg'
import portrait03 from '../assets/images/portrait/2017/03.jpg'
import portrait04 from '../assets/images/portrait/2017/04.jpg'
import portrait05 from '../assets/images/portrait/2017/05.jpg'
import portrait06 from '../assets/images/portrait/2017/06.jpg'
import portrait07 from '../assets/images/portrait/2017/07.jpg'
import portrait08 from '../assets/images/portrait/2017/08.jpg'
import portrait09 from '../assets/images/portrait/2017/09.jpg'
import portrait10 from '../assets/images/portrait/2017/10.jpg'
import portrait11 from '../assets/images/portrait/2017/11.jpg'
import portrait12 from '../assets/images/portrait/2017/12.jpg'
import portrait13 from '../assets/images/portrait/2017/13.jpg'
import portrait14 from '../assets/images/portrait/2017/14.jpg'
import portrait15 from '../assets/images/portrait/2017/15.jpg'
import portrait16 from '../assets/images/portrait/2017/16.jpg'
import portrait17 from '../assets/images/portrait/2017/17.jpg'
import portrait18 from '../assets/images/portrait/2017/18.jpg'
import portrait19 from '../assets/images/portrait/2017/19.jpg'
import portrait20 from '../assets/images/portrait/2017/20.jpg'
import portrait21 from '../assets/images/portrait/2017/21.jpg'
import portrait22 from '../assets/images/portrait/2017/22.jpg'
import thumb01 from '../assets/images/portrait/2017/01.jpg'
import thumb02 from '../assets/images/portrait/2017/02.jpg'
import thumb03 from '../assets/images/portrait/2017/03.jpg'
import thumb04 from '../assets/images/portrait/2017/04.jpg'
import thumb05 from '../assets/images/portrait/2017/05.jpg'
import thumb06 from '../assets/images/portrait/2017/06.jpg'
import thumb07 from '../assets/images/portrait/2017/07.jpg'
import thumb08 from '../assets/images/portrait/2017/08.jpg'
import thumb09 from '../assets/images/portrait/2017/09.jpg'
import thumb10 from '../assets/images/portrait/2017/10.jpg'
import thumb11 from '../assets/images/portrait/2017/11.jpg'
import thumb12 from '../assets/images/portrait/2017/12.jpg'
import thumb13 from '../assets/images/portrait/2017/13.jpg'
import thumb14 from '../assets/images/portrait/2017/14.jpg'
import thumb15 from '../assets/images/portrait/2017/15.jpg'
import thumb16 from '../assets/images/portrait/2017/16.jpg'
import thumb17 from '../assets/images/portrait/2017/17.jpg'
import thumb18 from '../assets/images/portrait/2017/18.jpg'
import thumb19 from '../assets/images/portrait/2017/19.jpg'
import thumb20 from '../assets/images/portrait/2017/20.jpg'
import thumb21 from '../assets/images/portrait/2017/21.jpg'
import thumb22 from '../assets/images/portrait/2017/22.jpg'
import pcthumb01 from '../assets/images/portrait/2017/thumbnail/01.jpg'
import pcthumb02 from '../assets/images/portrait/2017/thumbnail/02.jpg'
import pcthumb03 from '../assets/images/portrait/2017/thumbnail/03.jpg'
import pcthumb04 from '../assets/images/portrait/2017/thumbnail/04.jpg'
import pcthumb05 from '../assets/images/portrait/2017/thumbnail/05.jpg'
import pcthumb06 from '../assets/images/portrait/2017/thumbnail/06.jpg'
import pcthumb07 from '../assets/images/portrait/2017/thumbnail/07.jpg'
import pcthumb08 from '../assets/images/portrait/2017/thumbnail/08.jpg'
import pcthumb09 from '../assets/images/portrait/2017/thumbnail/09.jpg'
import pcthumb10 from '../assets/images/portrait/2017/thumbnail/10.jpg'
import pcthumb11 from '../assets/images/portrait/2017/thumbnail/11.jpg'
import pcthumb12 from '../assets/images/portrait/2017/thumbnail/12.jpg'
import pcthumb13 from '../assets/images/portrait/2017/thumbnail/13.jpg'
import pcthumb14 from '../assets/images/portrait/2017/thumbnail/14.jpg'
import pcthumb15 from '../assets/images/portrait/2017/thumbnail/15.jpg'
import pcthumb16 from '../assets/images/portrait/2017/thumbnail/16.jpg'
import pcthumb17 from '../assets/images/portrait/2017/thumbnail/17.jpg'
import pcthumb18 from '../assets/images/portrait/2017/thumbnail/18.jpg'
import pcthumb19 from '../assets/images/portrait/2017/thumbnail/19.jpg'
import pcthumb20 from '../assets/images/portrait/2017/thumbnail/20.jpg'
import pcthumb21 from '../assets/images/portrait/2017/thumbnail/21.jpg'
import pcthumb22 from '../assets/images/portrait/2017/thumbnail/22.jpg'
import Gallery from '../components/Gallery'
import Layout from '../components/layout'
import Helmet from 'react-helmet'
import Worksnav from '../components/Worksnav'


const DEFAULT_IMAGES = [
  {
    id: '1',
    source: portrait01,
    thumbnail: pcthumb01,
    caption: 'Photo 1',
    description: 'Mai Kiryu for "0.1cm "(2017)',
  },
  {
    id: '2',
    source: portrait02,
    thumbnail: pcthumb02,
    caption: 'Photo 2',
    description: 'Minako Akatsuka',
  },
  {
    id: '3',
    source: portrait03,
    thumbnail: pcthumb03,
    caption: 'Photo 3',
    description: 'Hiroto Kanai for i-D Japan strait up',
  },
  {
    id: '4',
    source: portrait04,
    thumbnail: pcthumb04,
    caption: 'Photo 4',
    description: 'Daiki Tsuneta',
  },
  {
    id: '5',
    source: portrait05,
    thumbnail: pcthumb05,
    caption: 'Photo 5',
    description: 'Riona for KISHIDAMIKI',
  },
  {
    id: '6',
    source: portrait06,
    thumbnail: pcthumb06,
    caption: 'Photo 6',
    description: 'Eriko Nakamura',
  },
  {
    id: '7',
    source: portrait07,
    thumbnail: pcthumb07,
    caption: 'Photo 7',
    description: '',
  },
  {
    id: '8',
    source: portrait08,
    thumbnail: pcthumb08,
    caption: 'Photo 8',
    description: 'MEGUMI',
  },
  {
    id: '9',
    source: portrait09,
    thumbnail: pcthumb09,
    caption: 'Photo 9',
    description: 'Hyunri for "0.1cm"(2017)',
  },
  {
    id: '10',
    source: portrait10,
    thumbnail: pcthumb10,
    caption: 'Photo 10',
    description: 'Satoru Iguchi for i-D Japan strait up',
  },
  {
    id: '11',
    source: portrait11,
    thumbnail: pcthumb11,
    caption: 'Photo 11',
    description: 'Kaito Yoshimura and Ryuya Wakaba for「サラバ静寂」',
  },
  {
    id: '12',
    source: portrait12,
    thumbnail: pcthumb12,
    caption: 'Photo 12',
    description: 'Minako Akatsuka',
  },
  {
    id: '13',
    source: portrait13,
    thumbnail: pcthumb13,
    caption: 'Photo 13',
    description: 'Yuya Matsuura',
  },
  {
    id: '14',
    source: portrait14,
    thumbnail: pcthumb14,
    caption: 'Photo 14',
    description: 'SHOKO for i-D Japan strait up',
  },
  {
    id: '15',
    source: portrait15,
    thumbnail: pcthumb15,
    caption: 'Photo 15',
    description: 'Mai kiryu for i-D Japan strait up',
  },
  {
    id: '16',
    source: portrait16,
    thumbnail: pcthumb16,
    caption: 'Photo 16',
    description: 'Daiki Tsuneta for 「Tokyo Rendez-Vous」',
  },
  {
    id: '17',
    source: portrait17,
    thumbnail: pcthumb17,
    caption: 'Photo 17',
    description: 'Taichi Saotome for Nehanne MIHARA YASUHIRO 2019SS',
  },
  {
    id: '18',
    source: portrait18,
    thumbnail: pcthumb18,
    caption: 'Photo 18',
    description: 'Kokoro Morita for i-D Japan strait up',
  },
  {
    id: '19',
    source: portrait19,
    thumbnail: pcthumb19,
    caption: 'Photo 19',
    description: '',
  },
  {
    id: '20',
    source: portrait20,
    thumbnail: pcthumb20,
    caption: 'Photo 20',
    description: 'Ryuku Kobayashi for "ZÔTÔKA" (2017)',
  },
  {
    id: '21',
    source: portrait21,
    thumbnail: pcthumb21,
    caption: 'Photo 21',
    description: 'Nijiro Murakami for "ZÔTÔKA" (2017)',
  },
  {
    id: '22',
    source: portrait22,
    thumbnail: pcthumb22,
    caption: 'Photo 22',
    description: '',
  },
]

const DEFAULT_IMAGES2 = [
  {
    id: '1',
    source: portrait01,
    thumbnail: thumb01,
    caption: 'Photo 1',
    description: 'Mai Kiryu for "0.1cm "(2017)',
  },
  {
    id: '2',
    source: portrait02,
    thumbnail: thumb02,
    caption: 'Photo 2',
    description: 'Minako Akatsuka',
  },
  {
    id: '3',
    source: portrait03,
    thumbnail: thumb03,
    caption: 'Photo 3',
    description: 'Hiroto Kanai for i-D Japan strait up',
  },
  {
    id: '4',
    source: portrait04,
    thumbnail: thumb04,
    caption: 'Photo 4',
    description: 'Daiki Tsuneta',
  },
  {
    id: '5',
    source: portrait05,
    thumbnail: thumb05,
    caption: 'Photo 5',
    description: 'Riona for KISHIDAMIKI',
  },
  {
    id: '6',
    source: portrait06,
    thumbnail: thumb06,
    caption: 'Photo 6',
    description: 'Eriko Nakamura',
  },
  {
    id: '7',
    source: portrait07,
    thumbnail: thumb07,
    caption: 'Photo 7',
    description: '',
  },
  {
    id: '8',
    source: portrait08,
    thumbnail: thumb08,
    caption: 'Photo 8',
    description: 'MEGUMI',
  },
  {
    id: '9',
    source: portrait09,
    thumbnail: thumb09,
    caption: 'Photo 9',
    description: 'Hyunri for "0.1cm"(2017)',
  },
  {
    id: '10',
    source: portrait10,
    thumbnail: thumb10,
    caption: 'Photo 10',
    description: 'Satoru Iguchi for i-D Japan strait up',
  },
  {
    id: '11',
    source: portrait11,
    thumbnail: thumb11,
    caption: 'Photo 11',
    description: 'Kaito Yoshimura and Ryuya Wakaba for「サラバ静寂」',
  },
  {
    id: '12',
    source: portrait12,
    thumbnail: thumb12,
    caption: 'Photo 12',
    description: 'Minako Akatsuka',
  },
  {
    id: '13',
    source: portrait13,
    thumbnail: thumb13,
    caption: 'Photo 13',
    description: 'Yuya Matsuura',
  },
  {
    id: '14',
    source: portrait14,
    thumbnail: thumb14,
    caption: 'Photo 14',
    description: 'SHOKO for i-D Japan strait up',
  },
  {
    id: '15',
    source: portrait15,
    thumbnail: thumb15,
    caption: 'Photo 15',
    description: 'Mai kiryu for i-D Japan strait up',
  },
  {
    id: '16',
    source: portrait16,
    thumbnail: thumb16,
    caption: 'Photo 16',
    description: 'Daiki Tsuneta for 「Tokyo Rendez-Vous」',
  },
  {
    id: '17',
    source: portrait17,
    thumbnail: thumb17,
    caption: 'Photo 17',
    description: 'Taichi Saotome for Nehanne MIHARA YASUHIRO 2019SS',
  },
  {
    id: '18',
    source: portrait18,
    thumbnail: thumb18,
    caption: 'Photo 18',
    description: 'Kokoro Morita for i-D Japan strait up',
  },
  {
    id: '19',
    source: portrait19,
    thumbnail: thumb19,
    caption: 'Photo 19',
    description: '',
  },
  {
    id: '20',
    source: portrait20,
    thumbnail: thumb20,
    caption: 'Photo 20',
    description: 'Ryuku Kobayashi for "ZÔTÔKA" (2017)',
  },
  {
    id: '21',
    source: portrait21,
    thumbnail: thumb21,
    caption: 'Photo 21',
    description: 'Nijiro Murakami for "ZÔTÔKA" (2017)',
  },
  {
    id: '22',
    source: portrait22,
    thumbnail: thumb22,
    caption: 'Photo 22',
    description: '',
  },
]

const siteTitle = 'Onodera Ryo | portrait'

const Portrait2017 = class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
      nonClass: '',
    }
  }
  toggleNon = () => {
    console.log("111");
    this.setState({
      nonClass: 'is-active',
    })
  }

  componentDidMount() {
    setTimeout(() => {
      this.toggleNon();
    },700);
  }

  render() {
    return (
      <Layout>
        <Helmet>
          <title>{siteTitle}</title>
        </Helmet>
        <div id="main">
          <div className="portrait">
            <Worksnav>
              Portrait 2017
            </Worksnav>
            <div class={`gall ${this.state.nonClass}`}>
            <MediaQuery query="(min-width: 767px)">
              <Gallery
                      images={DEFAULT_IMAGES.map(
                        ({ id, source, thumbnail, caption, description }) => ({
                          source,
                          thumbnail,
                          caption,
                          description,
                        })
                      )}
              />
            </MediaQuery>
            <MediaQuery query="(max-width: 767px)">
              <Gallery
                      images={DEFAULT_IMAGES2.map(
                        ({ id, source, thumbnail, caption, description }) => ({
                          source,
                          thumbnail,
                          caption,
                          description,
                        })
                      )}
              />
            </MediaQuery>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default Portrait2017